import { AssertException } from '../assert.exception';

export class AssertIsNumberException extends AssertException {
  constructor(message?: string) {
    super(message);

    Object.setPrototypeOf(this, AssertIsNumberException.prototype);
  }
}
